import React, { useEffect } from "react";
import { useState, ReactNode } from "react";

function useErrorHandler() {
	const [error, setError] = useState<Error | null>(null);

	const handleError = (err: Error) => {
		setError(err);
	};

	return { error, handleError };
}

interface ErrorBoundaryProps {
	fallback: ReactNode;
	children: ReactNode;
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({
	fallback,
	children,
}) => {
	const { error, handleError } = useErrorHandler();

	useEffect(() => {
		try {
			// Assume we can run some rendering logic here
		} catch (err: unknown) {
			handleError(err as Error);
		}
	}, [handleError]);

	if (error) {
		return fallback || <h1>Something went wrong.</h1>;
	}

	return children;
};

export default ErrorBoundary;
